<template>
    <div class="shippingContainer margin_top_xl margin_bottom_md">
        <div class="row">
            <div class="col-lg-6">
                <h4 class="font-bold font-lg">Shipping Details</h4>
                <div class="margin_top_lg shippingContainer__details">
                    <h5 class="color__grey_light margin_bottom_md caps_upper font-sm">Current Address</h5>
                    <div class="row mb-3">
                        <div class="col-12 font-bold font-md">{{address.full_name}}</div>
                        <!-- <div class="col-6">raymonddpk@gmail.com</div> -->
                    </div>
                    <div class="row margin_bottom_md">
                        <div class="col-6">{{address.address}},{{address.city}}, {{address.state.name}}, Nigeria</div>
                        <div class="col-6">{{address.email}} <br>{{address.phone_no}}</div>
                    </div>
                    <button class="btn-link" @click="changeAddress">Change Address</button>
                </div>
                <div class="margin_top_lg margin_bottom_lg">
                    <submit-button type="button" :loading="creatingOrderPayment || creatingOrder" class="btn btn-secondary col-12" @click="makePayment">Continue to Payment</submit-button>
                </div>
            </div>
            <div class="col-lg-6">
                <order-summary @makePayment="makePayment" :creatingOrder="creatingOrder" v-if="order" :order="order" />
                <order-summary-cart @makePayment="makePayment" :creatingOrder="creatingOrder" v-else />
            </div>
        </div>
    </div>
</template>

<script>
import OrderSummaryCart from './OrderSummaryCart';
import OrderSummary from './OrderSummary';
import { mapState } from 'vuex';

export default {
    props:['addresses','creatingOrderPayment','order'],
    data() {
        return {
            creatingOrder: false,
            newOrder: ''
        }
    },
    computed: {
        address() {
            return this.addresses[0]
        },
        orderId() {
            return this.$route.params.id
        },
        subTotal() {
            return this.cart.reduce((sum, item) => {
                return sum + (item.crop.agg_kg_price * item.quantity)
            }, 0)
        },
        tax() {
            return this.subTotal * 0.05
        },
        total() {
            return this.subTotal + this.tax
        },
        
        ...mapState('offtaker',['cart']),
    },
    methods: {
        changeAddress() {
            this.$emit('changeContact')
        },
        createOrder() {
            this.creatingOrder = true;
            const obj = {
                shipping_amount: 0,
                tax_amount: this.tax
            }
            this.$http.post('crop_orders', obj)
            .then((response) => {
                this.newOrder = response.data;
                this.$log('Order created ', response.data)
                this.$router.push({
                    name: 'offtaker.orderpayment',
                    params: {
                        id: response.data.id
                    }
                })
            })
            .catch((error) => {
                this.$toastr.error(error)
            })
            .finally(() => {
                this.creatingOrder = false;
            })
        },
        makePayment() {
            if(this.orderId === 'false') {
                this.createOrder();
            } else {
                this.$router.push({
                    name: 'offtaker.orderpayment',
                    params: {
                        id: this.orderId
                    }
                })
            }
            
            
        }
    },
    components: {
        OrderSummary,
        OrderSummaryCart
    }
}
</script>

<style>

</style>